import fetch from '@/utils/fetch'


export function checkPermission(data = {}) {
  return fetch({
    url: '/saas/user/w/shop/permission/has',
    method: 'post',
    data
  })
}